<template>
    <v-dialog v-model="open" persistent max-width="400px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn block color="primary" dark v-bind="attrs" v-on="on">
                Text Messages
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Text Messages</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-list v-if="smsTemplates.length > 0">
                <v-list-group
                    v-for="template in smsTemplates"
                    :key="template.id"
                    v-model="template.active"
                    no-action
                >
                    <template v-slot:activator>
                        <v-container>
                            <v-list-item-content>
                                <v-list-item-title v-text="template.title"></v-list-item-title>
                            </v-list-item-content>
                        </v-container>
                    </template>
                    <TextMessageForm :template="template" />
                </v-list-group>
            </v-list>
            <v-list v-else>
                <v-list-item class="d-flex justify-center">
                    No templates
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="() => (open = false)">
                    Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="create">
                    Create
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from "vuex";
import TextMessageForm from "@/components/forms/TextMessageForm";

export default {
    name: "TextMessagesDialog",
    components: {
        TextMessageForm,
    },
    data() {
        return {
            open: false,
        };
    },
    computed: {
        ...mapGetters({
            smsTemplates: "templates/sms",
            user: "auth/user",
        }),
    },
    methods: {
        ...mapActions({
            loadSms: "templates/loadSms",
            showHandlerSnackbar: "snackbar/showHandlerSnackbar",
        }),
        ...mapMutations({
            ADD_SMS: "templates/ADD_SMS",
        }),
        create() {
            this.$axios.post('/templates/sms/create', {
                user_id: this.user.id,
                title: "New Template",
                text: "", 
            }).then(res => {
                this.ADD_SMS(res.data.template);

                this.showHandlerSnackbar({
                    color: "success",
                    text: res.data.message,
                    show: true,
                });

                this.smsTemplates.map(t => {
                    if (t.id === res.data.template.id) {
                        t.active = true;
                    } else {
                        t.active = false;
                    }

                    return t;
                });
            }).catch(e => {
                console.log('error', e);
            });
        }
    },
    mounted() {
        this.loadSms(this.user.id);
    },
};

</script>